import { render, staticRenderFns } from "./InsurerDeclarationSummary.vue?vue&type=template&id=958bc6cc&scoped=true"
import script from "./InsurerDeclarationSummary.vue?vue&type=script&lang=js"
export * from "./InsurerDeclarationSummary.vue?vue&type=script&lang=js"
import style0 from "./InsurerDeclarationSummary.vue?vue&type=style&index=0&id=958bc6cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958bc6cc",
  null
  
)

export default component.exports